<template>
  <svg class="xds:icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 18">
    <path
      d="M15.863 9.14279C9.98542 8.1632 9.98542 8.1632 9.00583 2.28564C8.02623 8.1632 8.02623 8.1632 2.14868 9.14279C8.02623 10.1224 8.02623 10.1224 9.00583 15.9999C9.98542 10.1224 9.98542 10.1224 15.863 9.14279Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2.70677"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      opacity="0.5"
      cx="15.8629"
      cy="2.28571"
      r="1.38346"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.80451"
    />
  </svg>
</template>
